"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizableImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var re_resizable_1 = require("re-resizable");
var getInitialSize = function (width, height) {
    return {
        width: width > 400 ? width : 400,
        height: height > 400 ? height : 400,
    };
};
var ResizableImage = function (_a) {
    var url = _a.url, width = _a.width, height = _a.height, alt = _a.alt, onResizeStop = _a.onResizeStop;
    var initialSize = getInitialSize(width, height);
    return ((0, jsx_runtime_1.jsxs)(re_resizable_1.Resizable, __assign({ size: initialSize, minWidth: 200, minHeight: 200, maxWidth: 1024, maxHeight: 1024, onResizeStop: function (e, direction, ref, d) {
            onResizeStop(width + d.width, height + d.height);
        }, style: {
            display: "inline-block",
            border: "2px dashed #888",
            background: "#fafafa",
            position: "relative",
        }, handleStyles: {
            bottomRight: { width: 24, height: 24, background: "#1976d2", borderRadius: "50%" },
        } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: url, alt: alt, style: { width: "100%", height: "100%", objectFit: "contain" }, className: "rounded shadow border" }), (0, jsx_runtime_1.jsx)("span", __assign({ style: {
                    position: "absolute",
                    right: 8,
                    bottom: 8,
                    color: "#1976d2",
                    fontWeight: "bold",
                    fontSize: 12,
                    background: "#fff",
                    borderRadius: 4,
                    padding: "2px 6px",
                    pointerEvents: "none",
                } }, { children: "Drag corner to resize" }))] })));
};
exports.ResizableImage = ResizableImage;
